export default "__VITE_ASSET__hdhkZQh3__"